<div class="flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
  <div class="flex justify-between gap-2">
    <tasks-task-data-target (click)="navigateToMemberProfile()">
      <mat-icon icon>account_circle</mat-icon>
      <span text>{{ task.data.memberName }}</span>
    </tasks-task-data-target>
    <p class="font-normal text-neutral-300">{{ formatDate(task.createdAt, true) }}</p>
  </div>
  <span
    class="w-fit rounded-full px-2 py-0.5 text-xs"
    [ngClass]="resultChipClass"
  >
    {{ "task.label.healthCheckInResult" + task.data.result | translate }}
  </span>
  @if (task.data.comment) {
    <tasks-multiline-text
      class="text-neutral-500"
      [text]="task.data.comment"
    />
  }
</div>

@if (task.status !== taskStatus.Resolved) {
  <div class="flex justify-end">
    <button
      class="btn btn-primary"
      type="button"
      [disabled]="chatLoading()"
      (click)="goToChat()"
    >
      {{ "task.action.goToChat" | translate }}
    </button>
  </div>
}
